var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder"},[_vm._t("componentName",function(){return [_vm._v("component name")]}),_vm._t("componentButtons"),_vm._t("componentData",function(){return [_vm._v("data needed for the component")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }